import { useTranslation } from "react-i18next";
import { useHoveredEditHandleStore } from "../../store/hoveredEditHandleStore";
import CanvasTooltip from "./CanvasTooltip";

// Renders the edit-handle hover tooltip. Must live outside <Canvas> (plain react-dom tree) —
// CanvasTooltip portals a real <div> to document.body, which the R3F reconciler can't host.
const EditHandleTooltipOverlay = () => {
    const { t } = useTranslation();
    const { tooltipKey, screenPosition } = useHoveredEditHandleStore();

    if (!tooltipKey || !screenPosition) return null;

    return <CanvasTooltip x={screenPosition.x} y={screenPosition.y} text={t(tooltipKey)} />;
};

export default EditHandleTooltipOverlay;
